export default __webpack_public_path__ + "static/PlayfairDisplay-VariableFont_wght-954c8a8c47a8828a1a45ae3aecd59d67.woff";